import React from 'react';

import DesktopNavActions from './desktop/DesktopNavActions';
import DesktopNavItem from './desktop/DesktopNavItem';
import MobileNav from './mobile/MobileNav';
import type { DesktopNavConfig, MobileNavConfig } from './types';

interface TopNavigationBarProps {
  desktop: DesktopNavConfig;
  mobile: MobileNavConfig;
  logoUrl: string;
}

export default function TopNavigationBar({
  desktop,
  mobile,
  logoUrl,
}: TopNavigationBarProps): JSX.Element {
  return (
    <nav className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white p-4 topnav:px-6 topnav:py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <a href="/" className="flex-shrink-0">
            <img src={logoUrl} alt="Storyblocks" width={151} height={32} />
          </a>
          <div className="hidden items-center topnav:flex">
            {desktop.navItems.map((item) => (
              <DesktopNavItem key={item.id} config={item} />
            ))}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <DesktopNavActions items={desktop.actions} />
          <MobileNav config={mobile} logoUrl={logoUrl} />
        </div>
      </div>
    </nav>
  );
}
